import React, { FunctionComponent } from 'react'

import { useFetchSubjectAreaSummary } from '../../utils/useFetchSubjectAreaSummary'
import { SubjectDetailAreaSummaryChart } from '../SubjectDetailAreaSummaryChart/SubjectDetailAreaSummaryChart'
import { SubjectDetailAreaSummaryTable } from '../SubjectDetailAreaSummaryTable/SubjectDetailAreaSummaryTable'

export interface SubjectDetailAreaSummaryTabProps {
  subjectId: string
}

export const SubjectDetailAreaSummaryTab: FunctionComponent<SubjectDetailAreaSummaryTabProps> =
  props => {
    const dataSource = useFetchSubjectAreaSummary(props.subjectId)

    return (
      <div className="flex gap-6 flex-wrap-reverse xl:flex-nowrap">
        <SubjectDetailAreaSummaryTable dataSource={dataSource} />
        <SubjectDetailAreaSummaryChart data={dataSource?.data || []} />
      </div>
    )
  }
